import { useCallback, useMemo } from 'react';
import { RewardableTransaction } from './types';
import { useService } from '../common';

const API = {
    LIST_ALL: '/rewardable/list',
    SYNC: '/rewardable/sync'
};

export const useRewardableService = () => {
    const service = useService();
    const getAll = useCallback((): Promise<RewardableTransaction[]> => {
        return service.sendGetWithAuthorization(API.LIST_ALL)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);

    const triggerSync = useCallback((): Promise<void> => {
        return service.sendPostWithAuthorization(API.SYNC, {})
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);

    return useMemo(() => ({
        getAll,
        triggerSync
    }), [getAll, triggerSync]);
};
